import {
    RECEIVE_APP_TYPE
} from '../../actions/appActions';

const AppTypeReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_APP_TYPE:
            return action.appType;

        default:
            return state;
    }
};

export default AppTypeReducer;